import { InvoiceStatus } from './invoice-status';
import { InvoiceAccountingStatus } from './invoice-accounting-status';
import { InvoiceType } from '@admin/billing/invoices/shared/models/invoice-type';

export class InvoiceListItemModel {
  fromObject(object: any): InvoiceListItemModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public invoiceId: number;
  public code: string;
  public createDate: Date;
  public activationDate: Date;
  public invoiceFileId: string;

  public customerId: number;
  public payerName: string;
  public payerTaxId: string;
  public payerVatStatusName: string;

  public totalAmount: number;

  public statusId: InvoiceStatus;
  public statusName: string;
  public isApproved: boolean;
  public isEdited: boolean;

  public invoiceTypeId: InvoiceType;

  public isSent: boolean;
  public sendDate: Date;

  public accountingStatusId: InvoiceAccountingStatus;
  public accountingStatusName: InvoiceAccountingStatus;

  public transactionCodes: string[];
  public transactionContent: string[];
  public paymentCodes: string[];
  public accountManagerFullNames: string[];

  public getInvoiceContent() {
    if (!this.transactionContent || this.transactionContent.length == 0)
      return '';

    var res = '';
    this.transactionContent.forEach(function (name) {
      if (name) {
        let hyphenIdx = name.indexOf(' - ');
        if (hyphenIdx !== -1)
          res +=
            '/ <b>' +
            name.substring(0, hyphenIdx) +
            '</b>' +
            name.substring(hyphenIdx) +
            ', ';
        else res += name + ', ';
      }
    });
    res = res.replace(', /', ' /');
    if (res[0] == '/') res = res.substring(2);
    return res.substring(0, res.length - 2);
  }
}
